"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHighchartsData = exports.getNumber = exports.getRow = exports.getRows = void 0;
const tslib_1 = require("tslib");
const head_1 = tslib_1.__importDefault(require("lodash/head"));
const values_1 = tslib_1.__importDefault(require("lodash/values"));
function getRows(result) {
    return (result && result.data[result.periods[0]]) || [];
}
exports.getRows = getRows;
function getRow(result) {
    const rows = getRows(result);
    return (0, head_1.default)(rows) || {};
}
exports.getRow = getRow;
function getNumber(result) {
    const row = getRow(result);
    const vals = (0, values_1.default)(row);
    return (0, head_1.default)(vals) || 0;
}
exports.getNumber = getNumber;
function getHighchartsData(result) {
    return (result.periods || []).map(period => {
        const periodData = (0, head_1.default)(result.data[period]);
        const vals = (0, values_1.default)(periodData);
        const firstProp = (0, head_1.default)(vals) || 0;
        return { x: period, y: firstProp };
    });
}
exports.getHighchartsData = getHighchartsData;
